module.exports = __webpack_public_path__ + "img/callnumber-poster-bg.d482f9b9.png";